/**
 * @ngdoc Controller
 * @name InstallationProxyController
 */

(function () {
    'use strict';

    angular.module('vrm.core')
        .controller('InstallationProxyController', InstallationProxyController);

    /**
     * @constructor
     * @ngInject
     */
    function InstallationProxyController(
        $timeout,
        $state,
        $log,
        ApiService,
        vrmNotificationsService,
        vrmNotificationType,
        InstallationsService,
        $stateParams,
        $scope,
        locale
    ) {

        $log.info('InstallationProxyController');
        $scope.$watch("$parent.installation", function (installation) {
            if (!installation) return;
            redirectUnauthorizedUser(installation);
            // Redirect the user if they are not authorized to view/use "Venus OS Large"
            if (!(installation.view_permissions.nodered || installation.view_permissions.signalk)) {
                $state.go('base.installation.dashboard');
                locale.ready('proxy').then(function () {
                    vrmNotificationsService.add({
                        type: vrmNotificationType.ERROR,
                        message: locale.getString('proxy.unavailable'),
                    });
                });
                return;
            }

            // Inform user if NodeRed Service is not running
            if (installation.view_permissions.nodered && !installation.nodered_running) {
                locale.ready('proxy').then(function () {
                    vrmNotificationsService.add({
                        type: vrmNotificationType.ERROR,
                        message: locale.getString('proxy.nodered_not_running'),
                    });
                });
            } else if (installation.view_permissions.nodered && installation.nodered_running) {
                setProxyUrl('nodered').then(function () {
                    if (installation.view_permissions.nodered_dash) {
                        $scope.nodered_dash = $scope.nodered + '&next=/ui';
                        $scope.$digest();
                    }

                    if (installation.view_permissions.nodered_dash_v2) {
                        $scope.nodered_dash_v2 = $scope.nodered + '&next=/dashboard';
                        $scope.$digest();
                    }
                });
            }

            // Use signalk_setting flag to imply that signalk service is running
            if (installation.view_permissions.signalk) {
                setProxyUrl('signalk');
            }
        });

        const redirectUnauthorizedUser = (installation) => {
            if (!installation.view_permissions.update_settings) {
                InstallationsService.redirectUnauthorizedUser(installation);
            }
        }

        async function setProxyUrl(proxy) {
            await ApiService.call('/installations/' + $stateParams.id + '/proxy-relay/' + proxy).then(function (response) {
                $scope[proxy] = 'https://' +
                    response.data.proxy_relay.replace('*', $stateParams.id + '-' + proxy) + '' +
                    '/proxyauthorize?proxytoken=' +
                    response.data.token;
            }).catch(function () {
                $state.go('base.installation.dashboard');
            });
        }
    }
})();
